import { BaccaratOutcome, BaccaratPhase, CardPosition, DealerAssistTableErrorCode, FlagStateType } from './baccarat-enums.model';
import { BaccaratState } from './baccarat-state.model';
import { Card } from './cards.enum';
import { ChatMessage as ChatMessageModel } from './chat-message.model';

export enum BaccaratEventType {
    CardBurn = 'card-burn',
    CardDealt = 'card-dealt',
    ChatMessage = 'chat-message',
    CutCardDrawn = 'cut-card-drawn',
    DealerAssistTableError = 'dealer-assist-table-error',
    FlagStateChange = 'flag-state-change',
    GamePhaseChange = 'game-phase-change',
    GameStateChange = 'game-state-change',
    LoginChange = 'login-change',
    PlayerCountChange = 'player-count-change'
}

export interface LoginChangeEvent {
    old?: {
        id: string;
        name: string;
    };

    new?: {
        croupierId: string;
        name: string;
    };
}

export interface GamePhaseChangeEvent {
    phase: BaccaratPhase;
    roundId?: number;
    outcome?: BaccaratOutcome;
}

export interface GameStateChangeEvent {
    state: BaccaratState;
}

export interface PlayerCountChangeEvent {
    count: number;
}

export interface CardBurnEvent {
    card: Card; // Card that tells us how many card we will need to burn
    burnedCount: number;
    totalToBurnCount: number;
}

export interface CardDealtEvent {
    card: Card;
    cardPosition: CardPosition;
    bankerHandValue: number;
    playerHandValue: number;
    nextCardPosition?: CardPosition;
    outcome?: BaccaratOutcome;
}

export interface FlagStateChangeEvent {
    flag: FlagStateType;
    state: boolean;
}

export interface DealerAssistTableErrorEvent {
    errorCode: DealerAssistTableErrorCode;
    context?: unknown;
}

export type ChatMessageEvent = ChatMessageModel;
